import Api from '@/services/Api'
const path = 'ledger'

export default {
    getLedger(page, addressId, externalId, startDate, endDate, showOnlyRedDocs, docType, orderDirection) {
        if (!showOnlyRedDocs) {
            showOnlyRedDocs = null;
        }
        return Api().get(path, {
            params: {
                page,
                addressId,
                externalId,
                startDate,
                endDate,
                showOnlyRedDocs,
                docType,
                orderDirection
            }
        })
    },
    getLedgerAdmin(page, clientId,addressId, externalId, startDate, endDate, showOnlyRedDocs, docType, orderDirection) {
        if (!showOnlyRedDocs) {
            showOnlyRedDocs = null;
        }
        return Api().get('ledgeradmin', {
            params: {
                page,
                clientId,
                addressId,
                externalId,
                startDate,
                endDate,
                showOnlyRedDocs,
                docType,
                orderDirection
            }
        })
    },
    getLedgerSalesman(page, clientId,addressId, externalId, startDate, endDate, showOnlyRedDocs, docType, orderDirection) {
        if (!showOnlyRedDocs) {
            showOnlyRedDocs = null;
        }
        return Api().get('ledgersalesman', {
            params: {
                page,
                clientId,
                addressId,
                externalId,
                startDate,
                endDate,
                showOnlyRedDocs,
                docType,
                orderDirection
            }
        })
    },
    getBalance(addressId) {
        return Api().get(path + `/balance`, {
            params: {
                addressId
            }
        })
    },
    getBalanceAdmin(clientId, addressId) {
        return Api().get(path + `/balanceadmin`, {
            params: {
                clientId,
                addressId
            }
        })
    },
    getBalanceSalesman(clientId, addressId) {
        return Api().get(path + `/balancesalesman`, {
            params: {
                clientId,
                addressId
            }
        })
    },
    print(addressId, startDate, endDate, showOnlyRedDocs, includeDetails, convertValues, defaultCurrency, docType) {
        if (!showOnlyRedDocs) {
            showOnlyRedDocs = null;
        }

        return Api().post(path + '/print', {
            addressId,
            startDate,
            endDate,
            showOnlyRedDocs,
            includeDetails,
            convertValues,
            defaultCurrency,
            docType
        });
    },
    printSalesman(clientId,addressId, startDate, endDate, showOnlyRedDocs, includeDetails, convertValues, defaultCurrency, docType) {
        if (!showOnlyRedDocs) {
            showOnlyRedDocs = null;
        }

        return Api().post(path + '/printsalesman', {
            clientId,
            addressId,
            startDate,
            endDate,
            showOnlyRedDocs,
            includeDetails,
            convertValues,
            defaultCurrency,
            docType
        });
    },
    printAdmin(clientId,addressId, startDate, endDate, showOnlyRedDocs, includeDetails, convertValues, defaultCurrency, docType) {
        if (!showOnlyRedDocs) {
            showOnlyRedDocs = null;
        }

        return Api().post(path + '/printadmin', {
            clientId,
            addressId,
            startDate,
            endDate,
            showOnlyRedDocs,
            includeDetails,
            convertValues,
            defaultCurrency,
            docType
        });
    },
    converFile(data) {
        return Api().post(
            path + `/convert`,
            data, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        )
    },
}